import React, { useEffect, useState } from 'react';

/**
 * EuropcarDataLayerSpec: Europcar web geliştirme ekibine gönderilecek dataLayer
 * ölçüm spesifikasyonu — eksik GA4 olaylarının tanımı, parametre sözlüğü ve
 * kopyala-yapıştır kod örnekleri.
 * Route: /r/europcar-datalayer (sidebar'da VAR, tam ekran belge)
 *
 * İçerik statik. Bulgular 17 Ağu 2026'da canlı site (www.europcar.com.tr) üzerinde
 * uçtan uca bir rezervasyon araması yapılarak ve GA4 property 379356800 sorgulanarak
 * ölçüldü; belgeye gömülü.
 *
 * 🔑 Belge web ekibine PDF olarak gidiyor. İçindeki "PDF olarak kaydet" düğmesi
 * iframe'in kendi belgesinde `window.print()` çağırır — tarayıcı yalnızca belgeyi
 * basar, dashboard'u değil. Dış sayfadan Ctrl+P ise `position:fixed` iframe'i tek
 * sayfaya kırpar, o yüzden düğme belgenin İÇİNDE duruyor; kaldırma.
 *
 * HTML modülü ~80KB (Glowytics logosu data URI olarak gömülü). Ana bundle'da işi
 * yok, dinamik import ile yükleniyor.
 */
export default function EuropcarDataLayerSpec() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./europcarDataLayerHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#0C1222">Belge yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini belgenin kendi zeminiyle aynı (--ground açık tema) — flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F5F6FA' }} />;

  return (
    <iframe
      title="Europcar · dataLayer Ölçüm Spesifikasyonu"
      srcDoc={html}
      style={fill}
    />
  );
}
